import Cookies from "js-cookie";
import snakeCase from "lodash/snakeCase";
import React, { ReactNode, useEffect } from "react";
import { useRecoilValue } from "recoil";

import { getBrowserPlatform, getUtm } from "src/utils/tracking";

import { track } from "../dataTracking";
import { getViewPageEventName } from "../dataTracking/events";
import { patientState } from "../states";

interface Props {
  pageName?: string;
  metadata?: object;
  children: React.ReactNode;
}

function TrackingWrapper({ pageName, metadata, children }: Props) {
  const patient = useRecoilValue(patientState);

  useEffect(() => {
    (async () => {
      await track(
        getViewPageEventName(pageName),
        metadata ?? {
          "Browser Platform": getBrowserPlatform()
        },
        patient
      );
    })();
  }, [patient, pageName, metadata]);

  return <>{children}</>;
}

export default TrackingWrapper;

export const setUtm = () => {
  // get from query string, if not exist, remove cookie
  // this cookie is used for
  // + next-auth which need this info for identify user
  // + checkout
  const utm = getUtm();
  Object.keys(utm).forEach((key) => {
    if (utm[key]) {
      Cookies.set(snakeCase(key), utm[key], { expires: 1, path: "/" });
    } else {
      Cookies.remove(snakeCase(key));
    }
  });
};

export const TrackingDataWrapper = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    setUtm();
  }, []);

  return <>{children}</>;
};
